import { useMemo } from "react"
import { useLocation } from "react-router-dom"

function useQuery() {
  const location = useLocation()
  const parsedQuery = useMemo(() => new URLSearchParams(location.search), [location.search])

  return parsedQuery
}

export { useQuery }
